import React, { createContext, useContext, useState } from 'react';

const QuoteModalContext = createContext(null);

export const useQuoteModal = () => {
  const context = useContext(QuoteModalContext);
  if (!context) {
    throw new Error('useQuoteModal must be used within QuoteModalProvider');
  }
  return context;
};

export const QuoteModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [projectId, setProjectId] = useState(null);
  const [sourceUrl, setSourceUrl] = useState('');
  const [preselectedService, setPreselectedService] = useState('');

  const openQuoteModal = (options = {}) => {
    setProjectId(options.projectId || null);
    setSourceUrl(options.sourceUrl || window.location.href);
    setPreselectedService(options.preselectedService || '');
    setIsOpen(true);
  };

  const closeQuoteModal = () => {
    setIsOpen(false);
    setProjectId(null);
    setSourceUrl('');
    setPreselectedService('');
  };

  // Alias for consistency
  const openModal = openQuoteModal;

  return (
    <QuoteModalContext.Provider value={{ isOpen, openQuoteModal, openModal, closeQuoteModal, projectId, sourceUrl, preselectedService }}>
      {children}
    </QuoteModalContext.Provider>
  );
};
